import React, { Fragment } from "react";
import { navigate } from "@reach/router";
import WikiNavBar from "../components/navbar";
import Footer from "../components/footer";
import Editor from '../components/editor';
import useLogin from "../providers/use_login";


const NuevoArticuloPage = () => {

  const { user } = useLogin();

  if (!user?.activo) return <>
    <WikiNavBar isSticky={false} />
    <div style={{ height: 50 }} />
    <div className="container">
    <h4>Debe ingresar con una cuenta activada por la administración para poder crear propuestas de artículos</h4>
    </div>
    <Footer />
  </>

  return (
    <Fragment>
      <WikiNavBar isSticky={false} />
      <div className="container">
        <div style={{ height: 20 }} />
        <h2>Propuesta de Artículo</h2>
        <p>Rellena el siguiente formulario para proponer un nuevo artículo en nuestra Biblioteca.</p>
        <p>Te recomendamos primero dar una mirada a otros artículos de temáticas similares para que tengas una idea del estándar que seguimos. También es bueno que recuerdes que el Staff puede aceptarla o rechazarla.</p>
        <p>Antes de comenzar a escribir, es buena idea contactar a un aministrador del foro, contándole de modo general tu idea. Así sabrás si tu propuesta es coherente con nuestra ambientación.</p>
        <Editor onCancel={() => navigate('/')} onSave={() => {
          navigate('/')
          alert('Tu propuesta ha sido recibida. ¡Gracias por colaborar!. No aparecerá en la Biblioteca hasta que sea revisada y aprobada.')
        }} />
        <br />
        <br />
      </div>
      <Footer />
    </Fragment>
  );
};

export default NuevoArticuloPage;
